<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <v-container>
      <p class="headline white--text ml-5">Shifts</p>
      <div v-if="$store.state.admin != ''" class="" style="font-size: 13px">
        <div class="text-center" v-if="pageLoading">
          <v-progress-circular
            :size="70"
            :width="2"
            color="grey"
            indeterminate
          ></v-progress-circular>
        </div>

        <div v-if="$store.state.whichToShow == 'bingo'">
          <div
            v-if="!pageLoading"
            class="white pa-10 pl-1 pr-1"
            id="report"
            style="border-radius: 3px"
          >
            <v-layout row wrap justify-space-around="">
              <v-flex xs12 md5>
                <div id="chooseDate" class="ml-10 mr-10 pl-10">
                  <h4 class="mt-6 grey--text text--darken-1 ml-10">
                    Select bingo Report Date
                  </h4>

                  <v-menu rounded="lg" offset-y>
                    <template v-slot:activator="{ attrs, on }">
                      <v-btn
                        text
                        class="pl-6 pr-6 mt-2"
                        v-bind="attrs"
                        v-on="on"
                        outlined=""
                      >
                        {{ bingoChoosedDateRange }}
                      </v-btn>
                    </template>

                    <v-list>
                      <v-list-item-group
                        v-model="bingoGroup"
                        active-class="deep-purple--text text--accent-4"
                      >
                        <v-list-item
                          v-for="item in items"
                          :key="item"
                          @click="
                            if (item == 'Custom Range') {
                              dateDialog = true;
                            } else {
                              bingoGetDailyWorks(item);
                            }
                          "
                        >
                          <v-list-item-title>{{ item }}</v-list-item-title>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-menu>
                </div>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mb-15 pa-3 pt-0" style="font-size: 14px">
              <horizontal-scroll
                class="horizontal-scroll white pa-3 pl-0 pt-0"
                id="report"
              >
                <table
                  style="width: 100%"
                  class="ma-3 mt-2"
                  v-if="
                    bingoChoosenDate == 'Today' ||
                    bingoChoosenDate == 'Yesterday' ||
                    bingoChoosenDate == 'Last 15 days'
                  "
                >
                  <tr>
                    <th>Day</th>
                    <th>Full Name</th>
                    <th>No Game</th>

                    <th>Total Money</th>
                    <th>Paid Money</th>
                    <th>On Hand</th>
                  </tr>

                  <tr v-for="(shift, i) in bingoDailyReport" :key="i">
                    <td style="font-size: 11px">
                      <v-icon small>date_range</v-icon>
                      {{ weekday[new Date(shift.day).getDay()] }}
                      <br v-if="shift.date != ''" />
                      <span class="ml-4">{{ shift.date }}</span>
                    </td>
                    <td>
                      <span
                        v-for="(cashier, j) in shift.cashier"
                        :key="j + bingoDailyReport.length"
                      >
                        {{ cashier.fullName.split(",")[0].trim() }}
                        <br />
                      </span>
                    </td>

                    <td>
                      <span
                        v-for="(cashier, j) in shift.cashier"
                        :key="j + bingoDailyReport.length + 1001"
                      >
                        {{ cashier.noTicket }}
                        <br />
                      </span>
                    </td>

                    <td>
                      <span
                        v-for="(cashier, j) in shift.cashier"
                        :key="j + bingoDailyReport.length + 100"
                      >
                        {{ cashier.totalMoney.toFixed(2) }}
                        <span style="font-size: 11px">ETB</span>
                        <br />
                      </span>
                    </td>
                    <td>
                      <span
                        v-for="(cashier, j) in shift.cashier"
                        :key="j + bingoDailyReport.length + 200"
                      >
                        {{ cashier.paidMoney.toFixed(2) }}
                        <span style="font-size: 11px">ETB</span>
                        <br />
                      </span>
                    </td>
                    <td>
                      <span
                        v-for="(cashier, j) in shift.cashier"
                        :key="j + bingoDailyReport.length + 300"
                      >
                        {{ cashier.onHandMoney.toFixed(2) }}
                        <span style="font-size: 11px">ETB</span>
                        <br />
                      </span>
                    </td>
                  </tr>
                </table>

                <table style="width: 100%" class="ma-3 mt-2" v-else>
                  <tr>
                    <th>Day</th>
                    <th>Full Name</th>
                    <th>No Games</th>

                    <th>Total Money</th>
                    <th>Paid Money</th>
                    <th>On Hand</th>
                  </tr>

                  <tr v-for="(shift, i) in bingoDailyReport" :key="i">
                    <td style="font-size: 11px">
                      <v-icon small>date_range</v-icon>
                    </td>
                    <td>
                      <span>
                        {{
                          shift.fullName != undefined
                            ? shift.fullName.split(",")[0].trim()
                            : ""
                        }}
                      </span>
                    </td>

                    <td>
                      <span>
                        {{ shift.noTicket }}
                      </span>
                    </td>

                    <td>
                      <span>
                        {{ shift.totalMoney }}
                        <span style="font-size: 11px">ETB</span>
                      </span>
                    </td>
                    <td>
                      <span>
                        {{ shift.paidMoney }}
                        <span style="font-size: 11px">ETB</span>
                      </span>
                    </td>
                    <td>
                      <span>
                        {{ shift.onHandMoney }}
                        <span style="font-size: 11px">ETB</span>
                      </span>
                    </td>
                  </tr>
                </table>
              </horizontal-scroll>
            </v-layout>
          </div>
        </div>

        <v-dialog v-model="dateDialog" persistent max-width="420">
          <v-card class="">
            <v-card-title>
              Choose date range <v-spacer></v-spacer>
              <v-btn
                class="text-capitalize"
                dark
                color="blue"
                text
                @click="
                  dateDialog = false;
                  if (date1 != '' && date2 != '') {
                    if ($store.state.whichToShow == 'Dogs') {
                      getDailyWorks('Custom Range');
                    } else if ($store.state.whichToShow == 'bingo') {
                      bingoGetDailyWorks('Custom Range');
                    } else {
                      getDailyWorks('Custom Range');
                      bingoGetDailyWorks('Custom Range');
                    }
                  }
                "
              >
                GO
              </v-btn>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col cols="12" lg="6">
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="date1"
                        label="Date 1"
                        hint="YYYY-MM-DD format"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date1"
                      no-title
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" lg="6">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="date2"
                        label="Date 2"
                        hint="YYYY-MM-DD format"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date2"
                      no-title
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>

      <div v-else id="error" class="text-center mt-16">
        <p class="red--text text-center">Please login first</p>
        <a @click="$router.push({ name: 'login' })">login</a>
      </div>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import HorizontalScroll from "vue-horizontal-scroll";
import "vue-horizontal-scroll/dist/vue-horizontal-scroll.css";

export default {
  components: {
    HorizontalScroll,
  },
  data() {
    return {
      pageLoading: false,
      choosedDateRange: "",
      loadingCount: 0,
      dateDialog: false,

      date1: "",
      date2: "",
      menu1: false,
      menu2: false,

      dailyWork: [],
      weekday: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],

      monthNames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],

      dailyReport: [],
      choosenDate: "Last 15 days",

      items: [
        "Today",
        "Yesterday",
        "Last 15 days",
        "Last 7 days",
        "This Month",
        "Last Month",
        "This Year",
        "Custom Range",
      ],
      group: null,

      bingoChoosedDateRange: "",

      bingoDailyWork: [],
      bingoDailyReport: [],
      allDailyReport: [],
      bingoChoosenDate: "Last 15 days",

      bingoGroup: null,
      paidbingoMoneyFromYesterday: [],
      paidKenoMoneyFromYesterday: [],
      paidAllMoneyFromYesterday: [],
    };
  },

  methods: {
    async getDailyWorks(passedDate) {
      var today = new Date();
      this.choosenDate = passedDate;

      var firstDay = "";
      var date2 = "";
      var date1 = "";
      if (this.choosenDate == "Last 15 days") {
        firstDay = new Date(today.setDate(today.getDate() - 14));
        date2 = Date.now();

        this.choosedDateRange =
          this.formatDate(new Date(firstDay.getTime())) +
          " - " +
          this.formatDate(new Date(date2));
        date1 = new Date(
          this.formatDate(new Date(firstDay.getTime()))
        ).getTime();
      } else if (this.choosenDate == "Today") {
        firstDay = new Date(today.setDate(today.getDate() - 0));
        date2 = Date.now();
        date1 =
          new Date(this.formatDate(new Date(Date.now()))).getTime() - 9688995;

        this.choosedDateRange =
          this.formatDate(new Date(firstDay.getTime())) +
          " - " +
          this.formatDate(new Date(date2));
      } else if (this.choosenDate == "Yesterday") {
        firstDay = new Date(today.setDate(today.getDate() - 1));
        date1 = new Date(
          this.formatDate(new Date(firstDay.getTime()))
        ).getTime();
        date2 =
          new Date(this.formatDate(new Date(Date.now()))).getTime() - 9688995;

        this.choosedDateRange =
          this.formatDate(new Date(firstDay.getTime())) +
          " - " +
          this.formatDate(new Date(firstDay.getTime()));
      } else if (this.choosenDate == "Last 7 days") {
        firstDay = new Date(today.setDate(today.getDate() - 6));
        date2 = Date.now();

        this.choosedDateRange =
          this.formatDate(new Date(firstDay.getTime())) +
          " - " +
          this.formatDate(new Date(date2));
        date1 = new Date(
          this.formatDate(new Date(firstDay.getTime()))
        ).getTime();
      } else if (this.choosenDate == "This Year") {
        firstDay = new Date(today.setDate(today.getDate() - 29));
        date2 = Date.now();

        this.choosedDateRange =
          this.formatDate(new Date(date2)).split("-")[0] +
          "-01-01" +
          " - " +
          this.formatDate(new Date(date2));
        date1 = new Date(
          this.formatDate(new Date(date2)).split("-")[0] + "-01-01"
        ).getTime();
      } else if (this.choosenDate == "This Month") {
        firstDay = this.formatDate(new Date(Date.now())).substring(0, 8) + "01";

        date2 = Date.now();

        this.choosedDateRange =
          firstDay + " - " + this.formatDate(new Date(date2));
        date1 = new Date(firstDay).getTime();
      } else if (this.choosenDate == "Last Month") {
        firstDay = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          1
        ).getTime();

        date2 = new Date(today.getFullYear(), today.getMonth(), 0).getTime();

        this.choosedDateRange =
          this.formatDate(firstDay) + " - " + this.formatDate(new Date(date2));
        date1 = firstDay;
      } else if (this.choosenDate == "Custom Range") {
        date2 = new Date(this.date2).getTime();
        this.choosedDateRange = this.date1 + " - " + this.date2;
        date1 = new Date(this.date1).getTime();
      }

      if (this.loadingCount == 0) this.pageLoading = true;
      try {
        var dailyResult = await axios({
          method: "POST",
          url: this.$store.state.adminURL,

          data: {
            query: `{
               getDailyWorksWithOutCashOut(date1:"${date1}", date2:"${date2}"){
                       ticket_id
                       game_id
                       user_id
                       choosen_numbers
                       others
                       ticket_date
                       winner_award
                       is_cancelled
                       is_cashout
                       cashier_id
                       payer_cashier_id
                       getCashier{
                           cashier_id
                           cashier_full_name
                           cashier_phone
                           cashier_address
                           user_name
                           is_active
                         }
                        getGameForShifts{
                         game_id
                         game_date

                       }

                   }
              }
              `,
          },
        });
        this.dailyWork = dailyResult.data.data.getDailyWorksWithOutCashOut;

        var allDays = [];
        var allCashiers = [];
        this.dailyReport = [];

        for (let t = 0; t < this.dailyWork.length; t++) {
          // var day = new Date(Number(this.dailyWork[t].ticket_date)).getDay();
          var day = this.formatDate(
            new Date(Number(this.dailyWork[t].ticket_date))
          );

          if (allDays.indexOf(day) === -1) allDays.push(day);

          var cashier = this.dailyWork[t].getCashier[0].cashier_full_name;
          var cid = this.dailyWork[t].getCashier[0].cashier_id;
          if (allCashiers.indexOf(cashier + "," + cid) === -1)
            allCashiers.push(cashier + "," + cid);
        }

        if (
          this.choosenDate == "Today" ||
          this.choosenDate == "Yesterday" ||
          this.choosenDate == "Last 15 days"
        ) {
          for (let d = 0; d < allDays.length; d++) {
            var eachCashier = [];
            var date = "";

            for (let c = 0; c < allCashiers.length; c++) {
              var totalMoneyForEach = 0;
              var totalPaidForEach = 0;
              var noTicket = 0;
              var nobet = 0;
              var noPaidTicket = 0;
              var nocancelledTicket = 0;
              var notCashoutTotalMoney = 0;
              var notCashoutPaidMoney = 0;

              for (let t = 0; t < this.dailyWork.length; t++) {
                // var day = new Date(
                //   Number(this.dailyWork[t].ticket_date)
                // ).getDay();

                var day = this.formatDate(
                  new Date(Number(this.dailyWork[t].ticket_date))
                );
                var cashierName =
                  this.dailyWork[t].getCashier[0].cashier_full_name;

                if (day == allDays[d]) {
                  if (cashierName == allCashiers[c].split(",")[0].trim()) {
                    var month =
                      this.monthNames[
                        new Date(
                          Number(this.dailyWork[t].ticket_date)
                        ).getMonth()
                      ];

                    var eachSplitedDate = this.formatDate(
                      new Date(Number(this.dailyWork[t].ticket_date))
                    ).split("-");
                    date =
                      month +
                      " " +
                      eachSplitedDate[2] +
                      "/" +
                      eachSplitedDate[0];

                    var tickets = this.dailyWork[t].choosen_numbers.split(":");

                    if (this.dailyWork[t].is_cancelled == 0) {
                      noTicket = noTicket + 1;

                      if (tickets[0] != "") {
                        nobet = nobet + tickets.length;
                        for (let j = 0; j < tickets.length; j++) {
                          totalMoneyForEach =
                            totalMoneyForEach +
                            parseFloat(tickets[j].split("*")[3]);

                          if (this.choosenDate == "Today") {
                            notCashoutTotalMoney =
                              notCashoutTotalMoney +
                              parseFloat(tickets[j].split("*")[3]);
                          }
                        }
                      }
                    } else nocancelledTicket = nocancelledTicket + 1;

                    if (
                      this.dailyWork[t].winner_award != 0 &&
                      this.dailyWork[t].payer_cashier_id ==
                        this.dailyWork[t].cashier_id
                    ) {
                      noPaidTicket = noPaidTicket + 1;
                      totalPaidForEach =
                        totalPaidForEach + this.dailyWork[t].winner_award;
                    }

                    if (
                      this.choosenDate == "Today" &&
                      this.dailyWork[t].is_cancelled == 0
                    ) {
                      notCashoutPaidMoney =
                        notCashoutPaidMoney + this.dailyWork[t].winner_award;
                    }
                  } else {
                    if (
                      this.dailyWork[t].winner_award != 0 &&
                      this.dailyWork[t].payer_cashier_id.toString() ==
                        allCashiers[c].split(",")[1].trim()
                    ) {
                      noPaidTicket = noPaidTicket + 1;
                      totalPaidForEach =
                        totalPaidForEach + this.dailyWork[t].winner_award;
                    }
                  }
                }
              }

              eachCashier.push({
                fullName: allCashiers[c],
                noTicket: noTicket,
                noPaidTicket: noPaidTicket,
                nocancelledTicket: nocancelledTicket,
                noBet: nobet,

                totalMoney: totalMoneyForEach,
                paidMoney: totalPaidForEach,
                onHandMoney: totalMoneyForEach - totalPaidForEach,
              });
            }

            this.dailyReport.push({
              day: allDays[d],
              date: date,
              cashier: eachCashier,
            });
          }

          if (this.choosenDate == "Today" && this.dailyReport.length > 0) {
            for (let to = 0; to < this.dailyReport[0].cashier.length; to++) {
              for (
                let fn = 0;
                fn < this.paidKenoMoneyFromYesterday.length;
                fn++
              ) {
                if (
                  this.dailyReport[0].cashier[to].fullName
                    .split(",")[0]
                    .trim() == this.paidKenoMoneyFromYesterday[fn].cashierName
                ) {
                  this.dailyReport[0].cashier[to].paidMoney =
                    this.dailyReport[0].cashier[to].paidMoney +
                    this.paidKenoMoneyFromYesterday[fn].paidMoney;

                  this.dailyReport[0].cashier[to].onHandMoney =
                    this.dailyReport[0].cashier[to].onHandMoney -
                    this.paidKenoMoneyFromYesterday[fn].paidMoney;
                }
              }
            }
          }

          this.allDailyReport = [];
          for (let a = 0; a < this.dailyReport.length; a++) {
            let matchDayCount = 0;
            var eachWorker = [];
            for (let b = 0; b < this.bingoDailyReport.length; b++) {
              if (
                this.dailyReport[a].day == this.bingoDailyReport[b].day &&
                this.dailyReport[a].date == this.bingoDailyReport[b].date
              ) {
                matchDayCount++;
                for (let c = 0; c < this.dailyReport[a].cashier.length; c++) {
                  let matchCashierCount = 0;
                  for (
                    let d = 0;
                    d < this.bingoDailyReport[b].cashier.length;
                    d++
                  ) {
                    if (
                      this.dailyReport[a].cashier[c].fullName
                        .split(",")[0]
                        .trim() ==
                      this.bingoDailyReport[b].cashier[d].fullName
                        .split(",")[0]
                        .trim()
                    ) {
                      matchCashierCount++;
                      eachWorker.push({
                        fullName: this.dailyReport[a].cashier[c].fullName
                          .split(",")[0]
                          .trim(),
                        noTicket:
                          this.dailyReport[a].cashier[c].noTicket +
                          this.bingoDailyReport[b].cashier[d].noTicket,
                        noPaidTicket:
                          this.dailyReport[a].cashier[c].noPaidTicket +
                          this.bingoDailyReport[b].cashier[d].noPaidTicket,
                        nocancelledTicket:
                          this.dailyReport[a].cashier[c].nocancelledTicket +
                          this.bingoDailyReport[b].cashier[d].nocancelledTicket,
                        noBet:
                          this.dailyReport[a].cashier[c].noBet +
                          this.bingoDailyReport[b].cashier[d].noBet,

                        totalMoney:
                          this.dailyReport[a].cashier[c].totalMoney +
                          this.bingoDailyReport[b].cashier[d].totalMoney,
                        paidMoney:
                          this.dailyReport[a].cashier[c].paidMoney +
                          this.bingoDailyReport[b].cashier[d].paidMoney,
                        onHandMoney:
                          this.dailyReport[a].cashier[c].onHandMoney +
                          this.bingoDailyReport[b].cashier[d].onHandMoney,
                      });
                    }
                  }
                  if (matchCashierCount == 0) {
                    eachWorker.push({
                      fullName: this.dailyReport[a].cashier[c].fullName
                        .split(",")[0]
                        .trim(),
                      noTicket: this.dailyReport[a].cashier[c].noTicket,
                      noPaidTicket: this.dailyReport[a].cashier[c].noPaidTicket,
                      nocancelledTicket:
                        this.dailyReport[a].cashier[c].nocancelledTicket,
                      noBet: this.dailyReport[a].cashier[c].noBet,

                      totalMoney: this.dailyReport[a].cashier[c].totalMoney,
                      paidMoney: this.dailyReport[a].cashier[c].paidMoney,
                      onHandMoney: this.dailyReport[a].cashier[c].onHandMoney,
                    });
                  }
                }
              }
            }

            if (matchDayCount == 0) {
              this.allDailyReport.push({
                day: this.dailyReport[a].day,
                date: this.dailyReport[a].date,
                cashier: this.dailyReport[a].cashier,
              });
            } else if (eachWorker.length > 0) {
              this.allDailyReport.push({
                day: this.dailyReport[a].day,
                date: this.dailyReport[a].date,
                cashier: eachWorker,
              });
            }
          }

          for (let a = 0; a < this.bingoDailyReport.length; a++) {
            let matchDayCount = 0;
            var eachWorker = [];
            for (let b = 0; b < this.dailyReport.length; b++) {
              if (
                this.bingoDailyReport[a].day == this.dailyReport[b].day &&
                this.bingoDailyReport[a].date == this.dailyReport[b].date
              ) {
                matchDayCount++;
                for (
                  let c = 0;
                  c < this.bingoDailyReport[a].cashier.length;
                  c++
                ) {
                  let matchCashierCount = 0;
                  for (let d = 0; d < this.dailyReport[b].cashier.length; d++) {
                    if (
                      this.bingoDailyReport[a].cashier[c].fullName
                        .split(",")[0]
                        .trim() ==
                      this.dailyReport[b].cashier[d].fullName
                        .split(",")[0]
                        .trim()
                    ) {
                      matchCashierCount++;
                    }
                  }
                  if (matchCashierCount == 0) {
                    eachWorker.push({
                      fullName: this.bingoDailyReport[a].cashier[c].fullName
                        .split(",")[0]
                        .trim(),
                      noTicket: this.bingoDailyReport[a].cashier[c].noTicket,
                      noPaidTicket:
                        this.bingoDailyReport[a].cashier[c].noPaidTicket,
                      nocancelledTicket:
                        this.bingoDailyReport[a].cashier[c].nocancelledTicket,
                      noBet: this.bingoDailyReport[a].cashier[c].noBet,

                      totalMoney:
                        this.bingoDailyReport[a].cashier[c].totalMoney,
                      paidMoney: this.bingoDailyReport[a].cashier[c].paidMoney,
                      onHandMoney:
                        this.bingoDailyReport[a].cashier[c].onHandMoney,
                    });
                  }
                }
              }
            }

            if (matchDayCount == 0) {
              this.allDailyReport.push({
                day: this.bingoDailyReport[a].day,
                date: this.bingoDailyReport[a].date,
                cashier: this.bingoDailyReport[a].cashier,
              });
            } else if (eachWorker.length > 0) {
              this.allDailyReport.push({
                day: this.bingoDailyReport[a].day,
                date: this.bingoDailyReport[a].date,
                cashier: eachWorker,
              });
            }
          }
        } else {
          this.dailyReport = [];

          for (let c = 0; c < allCashiers.length; c++) {
            var totalMoneyForEach = 0;
            var totalPaidForEach = 0;
            var noTicket = 0;
            var nobet = 0;
            var noPaidTicket = 0;
            var nocancelledTicket = 0;
            var notCashoutTotalMoney = 0;
            var notCashoutPaidMoney = 0;

            for (let t = 0; t < this.dailyWork.length; t++) {
              var cashierName =
                this.dailyWork[t].getCashier[0].cashier_full_name;

              if (cashierName == allCashiers[c].split(",")[0].trim()) {
                var tickets = this.dailyWork[t].choosen_numbers.split(":");

                if (this.dailyWork[t].is_cancelled == 0) {
                  noTicket = noTicket + 1;

                  if (tickets[0] != "") {
                    nobet = nobet + tickets.length;
                    for (let j = 0; j < tickets.length; j++) {
                      totalMoneyForEach =
                        totalMoneyForEach +
                        parseFloat(tickets[j].split("*")[3]);

                      if (this.dailyWork[t].is_cashout == 0) {
                        notCashoutTotalMoney =
                          notCashoutTotalMoney +
                          parseFloat(tickets[j].split("*")[3]);
                      }
                    }
                  }
                } else nocancelledTicket = nocancelledTicket + 1;

                // if (this.dailyWork[t].winner_award != 0)
                //   noPaidTicket = noPaidTicket + 1;
                // totalPaidForEach =
                //   totalPaidForEach + this.dailyWork[t].winner_award;

                if (
                  this.dailyWork[t].winner_award != 0 &&
                  this.dailyWork[t].payer_cashier_id ==
                    this.dailyWork[t].cashier_id
                ) {
                  noPaidTicket = noPaidTicket + 1;
                  totalPaidForEach =
                    totalPaidForEach + this.dailyWork[t].winner_award;
                }

                if (this.dailyWork[t].is_cashout == 0) {
                  notCashoutPaidMoney =
                    notCashoutPaidMoney + this.dailyWork[t].winner_award;
                }
              } else {
                if (
                  this.dailyWork[t].winner_award != 0 &&
                  this.dailyWork[t].payer_cashier_id.toString() ==
                    allCashiers[c].split(",")[1].trim()
                ) {
                  noPaidTicket = noPaidTicket + 1;
                  totalPaidForEach =
                    totalPaidForEach + this.dailyWork[t].winner_award;
                }
              }
            }

            this.dailyReport.push({
              fullName: allCashiers[c],
              noTicket: noTicket,
              noPaidTicket: noPaidTicket,
              nocancelledTicket: nocancelledTicket,
              noBet: nobet,

              totalMoney: totalMoneyForEach,
              paidMoney: totalPaidForEach,
              onHandMoney: totalMoneyForEach - totalPaidForEach,
            });
          }

          this.allDailyReport = [];

          for (let c = 0; c < this.dailyReport.length; c++) {
            let matchCashierCount = 0;
            for (let d = 0; d < this.bingoDailyReport.length; d++) {
              if (
                this.bingoDailyReport[d].fullName != undefined &&
                this.dailyReport[c].fullName != undefined
              )
                if (
                  this.dailyReport[c].fullName.split(",")[0].trim() ==
                  this.bingoDailyReport[d].fullName.split(",")[0].trim()
                ) {
                  matchCashierCount++;
                  this.allDailyReport.push({
                    fullName: this.dailyReport[c].fullName,
                    noTicket:
                      this.dailyReport[c].noTicket +
                      this.bingoDailyReport[d].noTicket,
                    noPaidTicket:
                      this.dailyReport[c].noPaidTicket +
                      this.bingoDailyReport[d].noPaidTicket,
                    nocancelledTicket:
                      this.dailyReport[c].nocancelledTicket +
                      this.bingoDailyReport[d].nocancelledTicket,
                    noBet:
                      this.dailyReport[c].noBet +
                      this.bingoDailyReport[d].noBet,

                    totalMoney:
                      this.dailyReport[c].totalMoney +
                      this.bingoDailyReport[d].totalMoney,
                    paidMoney:
                      this.dailyReport[c].paidMoney +
                      this.bingoDailyReport[d].paidMoney,
                    onHandMoney:
                      this.dailyReport[c].onHandMoney +
                      this.bingoDailyReport[d].onHandMoney,
                  });
                }
            }
            if (matchCashierCount == 0) {
              this.allDailyReport.push({
                fullName: this.dailyReport[c].fullName,
                noTicket: this.dailyReport[c].noTicket,
                noPaidTicket: this.dailyReport[c].noPaidTicket,
                nocancelledTicket: this.dailyReport[c].nocancelledTicket,
                noBet: this.dailyReport[c].noBet,

                totalMoney: this.dailyReport[c].totalMoney,
                paidMoney: this.dailyReport[c].paidMoney,
                onHandMoney: this.dailyReport[c].onHandMoney,
              });
            }
          }

          for (let c = 0; c < this.bingoDailyReport.length; c++) {
            let matchCashierCount = 0;
            for (let d = 0; d < this.dailyReport.length; d++) {
              if (
                this.bingoDailyReport[c].fullName != undefined &&
                this.dailyReport[d].fullName != undefined
              )
                if (
                  this.dailyReport[d].fullName.split(",")[0].trim() ==
                  this.bingoDailyReport[c].fullName.split(",")[0].trim()
                ) {
                  matchCashierCount++;
                }
            }
            if (matchCashierCount == 0) {
              this.allDailyReport.push({
                fullName: this.bingoDailyReport[c].fullName,
                noTicket: this.bingoDailyReport[c].noTicket,
                noPaidTicket: this.bingoDailyReport[c].noPaidTicket,
                nocancelledTicket: this.bingoDailyReport[c].nocancelledTicket,
                noBet: this.bingoDailyReport[c].noBet,

                totalMoney: this.bingoDailyReport[c].totalMoney,
                paidMoney: this.bingoDailyReport[c].paidMoney,
                onHandMoney: this.bingoDailyReport[c].onHandMoney,
              });
            }
          }
        }
        this.allDailyReport.sort(
          (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
        );
      } catch (err) {
        alert(err);
      }
      this.loadingCount++;
      this.pageLoading = false;
    },

    async bingoGetDailyWorks(passedDate) {
      var today = new Date();
      this.bingoChoosenDate = passedDate;

      var firstDay = "";
      var date2 = "";
      var date1 = "";
      if (this.bingoChoosenDate == "Last 15 days") {
        firstDay = new Date(today.setDate(today.getDate() - 14));
        date2 = Date.now();

        this.bingoChoosedDateRange =
          this.formatDate(new Date(firstDay.getTime())) +
          " - " +
          this.formatDate(new Date(date2));
        date1 = new Date(
          this.formatDate(new Date(firstDay.getTime()))
        ).getTime();
      } else if (this.bingoChoosenDate == "Today") {
        firstDay = new Date(today.setDate(today.getDate() - 0));
        date2 = Date.now();
        date1 =
          new Date(this.formatDate(new Date(Date.now()))).getTime() - 9688995;

        this.bingoChoosedDateRange =
          this.formatDate(new Date(firstDay.getTime())) +
          " - " +
          this.formatDate(new Date(date2));
      } else if (this.bingoChoosenDate == "Yesterday") {
        firstDay = new Date(today.setDate(today.getDate() - 1));
        date1 = new Date(
          this.formatDate(new Date(firstDay.getTime()))
        ).getTime();
        date2 =
          new Date(this.formatDate(new Date(Date.now()))).getTime() - 9688995;

        this.bingoChoosedDateRange =
          this.formatDate(new Date(firstDay.getTime())) +
          " - " +
          this.formatDate(new Date(firstDay.getTime()));
      } else if (this.bingoChoosenDate == "Last 7 days") {
        firstDay = new Date(today.setDate(today.getDate() - 6));
        date2 = Date.now();

        this.bingoChoosedDateRange =
          this.formatDate(new Date(firstDay.getTime())) +
          " - " +
          this.formatDate(new Date(date2));
        date1 = new Date(
          this.formatDate(new Date(firstDay.getTime()))
        ).getTime();
      } else if (this.bingoChoosenDate == "This Year") {
        firstDay = new Date(today.setDate(today.getDate() - 29));
        date2 = Date.now();

        this.bingoChoosedDateRange =
          this.formatDate(new Date(date2)).split("-")[0] +
          "-01-01" +
          " - " +
          this.formatDate(new Date(date2));
        date1 = new Date(
          this.formatDate(new Date(date2)).split("-")[0] + "-01-01"
        ).getTime();
      } else if (this.bingoChoosenDate == "This Month") {
        firstDay = this.formatDate(new Date(Date.now())).substring(0, 8) + "01";

        date2 = Date.now();

        this.bingoChoosedDateRange =
          firstDay + " - " + this.formatDate(new Date(date2));
        date1 = new Date(firstDay).getTime();
      } else if (this.bingoChoosenDate == "Last Month") {
        firstDay = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          1
        ).getTime();

        date2 = new Date(today.getFullYear(), today.getMonth(), 0).getTime();

        this.bingoChoosedDateRange =
          this.formatDate(firstDay) + " - " + this.formatDate(new Date(date2));
        date1 = firstDay;
      } else if (this.bingoChoosenDate == "Custom Range") {
        date2 = new Date(this.date2).getTime();
        this.bingoChoosedDateRange = this.date1 + " - " + this.date2;
        date1 = new Date(this.date1).getTime();
      }

      if (this.loadingCount == 0) this.pageLoading = true;
      try {
        var dailyResult = await axios({
          method: "POST",
          url: this.$store.state.bingoAdminURL,

          data: {
            query: `{
               getDailyWorksWithOutCashOut(date1:"${date1}", date2:"${date2}"){
                         game_id
                         cashier_id
                         game_number
                         drawn_numbers
                         game_date
                         stake
                         selected_cartela
                         winners_money
                         earning
                         getCashier{
                           cashier_id
                           cashier_full_name
                           cashier_phone
                           cashier_address
                           user_name
                           is_active
                         }
                     

                   }
              }
              `,
          },
        });
        this.bingoDailyWork = dailyResult.data.data.getDailyWorksWithOutCashOut;

        var allDays = [];
        var allCashiers = [];
        this.bingoDailyReport = [];

        for (let t = 0; t < this.bingoDailyWork.length; t++) {
          // var day = new Date(Number(this.dailyWork[t].ticket_date)).getDay();
          var day = this.formatDate(
            new Date(Number(this.bingoDailyWork[t].game_date))
          );

          if (allDays.indexOf(day) === -1) allDays.push(day);

          var cashier = this.bingoDailyWork[t].getCashier[0].cashier_full_name;
          var cid = this.bingoDailyWork[t].getCashier[0].cashier_id;
          if (allCashiers.indexOf(cashier + "," + cid) === -1)
            allCashiers.push(cashier + "," + cid);
        }

        if (
          this.bingoChoosenDate == "Today" ||
          this.bingoChoosenDate == "Yesterday" ||
          this.bingoChoosenDate == "Last 15 days"
        ) {
          for (let d = 0; d < allDays.length; d++) {
            var eachCashier = [];
            var date = "";

            for (let c = 0; c < allCashiers.length; c++) {
              var totalMoneyForEach = 0;
              var totalPaidForEach = 0;
              var noTicket = 0;

              for (let t = 0; t < this.bingoDailyWork.length; t++) {
                // var day = new Date(
                //   Number(this.dailyWork[t].ticket_date)
                // ).getDay();

                var day = this.formatDate(
                  new Date(Number(this.bingoDailyWork[t].game_date))
                );
                var cashierName =
                  this.bingoDailyWork[t].getCashier[0].cashier_full_name;

                if (day == allDays[d]) {
                  if (cashierName == allCashiers[c].split(",")[0].trim()) {
                    var month =
                      this.monthNames[
                        new Date(
                          Number(this.bingoDailyWork[t].game_date)
                        ).getMonth()
                      ];

                    var eachSplitedDate = this.formatDate(
                      new Date(Number(this.bingoDailyWork[t].game_date))
                    ).split("-");
                    date =
                      month +
                      " " +
                      eachSplitedDate[2] +
                      "/" +
                      eachSplitedDate[0];

                    noTicket = noTicket + 1;

                    totalMoneyForEach =
                      totalMoneyForEach +
                      this.bingoDailyWork[t].winners_money +
                      this.bingoDailyWork[t].earning;
                    totalPaidForEach =
                      totalPaidForEach + this.bingoDailyWork[t].winners_money;
                  }
                }
              }

              eachCashier.push({
                fullName: allCashiers[c],
                noTicket: noTicket,

                totalMoney: totalMoneyForEach,
                paidMoney: totalPaidForEach,
                onHandMoney: totalMoneyForEach - totalPaidForEach,
              });
            }

            this.bingoDailyReport.push({
              day: allDays[d],
              date: date,
              cashier: eachCashier,
            });
          }
        } else {
          this.bingoDailyReport = [];

          for (let c = 0; c < allCashiers.length; c++) {
            var totalMoneyForEach = 0;
            var totalPaidForEach = 0;
            var noTicket = 0;

            for (let t = 0; t < this.bingoDailyWork.length; t++) {
              var cashierName =
                this.bingoDailyWork[t].getCashier[0].cashier_full_name;

              if (cashierName == allCashiers[c].split(",")[0].trim()) {
                noTicket = noTicket + 1;

                totalMoneyForEach =
                  totalMoneyForEach +
                  this.bingoDailyWork[t].winners_money +
                  this.bingoDailyWork[t].earning;
                totalPaidForEach =
                  totalPaidForEach + this.bingoDailyWork[t].winners_money;
              }
            }

            this.bingoDailyReport.push({
              fullName: allCashiers[c],
              noTicket: noTicket,

              totalMoney: totalMoneyForEach,
              paidMoney: totalPaidForEach,
              onHandMoney: totalMoneyForEach - totalPaidForEach,
            });
          }
        }
      } catch (err) {
        alert(err);
      }
      this.loadingCount++;
      this.pageLoading = false;
    },

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },

    async getPaidFromYesterday() {
      var date2 = Date.now();
      var date1 =
        new Date(this.formatDate(new Date(Date.now()))).getTime() - 9688995;

      try {
        var paidMoneyKenoFromYesterdayResult = await axios({
          method: "POST",
          url: this.$store.state.bingoAdminURL,

          data: {
            query: `{
              getMoneyFromYesterdayByAdmin(date1:"${date1}", date2:"${date2}"){
                    paid_from_yesterday_id
                    cashier_id
                    user_id
                    winner_award
                    paid_date
                    getCashier{
                    cashier_full_name
                   }
                   }
              }
              `,
          },
        });

        var paidMoneyKenoFromYesterday =
          paidMoneyKenoFromYesterdayResult.data.data
            .getMoneyFromYesterdayByAdmin;
        this.paidbingoMoneyFromYesterday = [];

        var cashiers = [];

        for (let k = 0; k < paidMoneyKenoFromYesterday.length; k++) {
          cashiers.push(
            paidMoneyKenoFromYesterday[k].getCashier[0].cashier_full_name
          );
        }

        let uniqueCashiers = [...new Set(cashiers)];

        for (let c = 0; c < uniqueCashiers.length; c++) {
          var eachPiad = 0;
          for (let k = 0; k < paidMoneyKenoFromYesterday.length; k++) {
            if (
              uniqueCashiers[c] ==
              paidMoneyKenoFromYesterday[k].getCashier[0].cashier_full_name
            ) {
              eachPiad = eachPiad + paidMoneyKenoFromYesterday[k].winner_award;
            }
          }

          this.paidbingoMoneyFromYesterday.push({
            cashierName: uniqueCashiers[c],
            paidMoney: eachPiad,
          });
        }

        this.paidAllMoneyFromYesterday = [];
        for (let p = 0; p < this.paidKenoMoneyFromYesterday.length; p++) {
          let matchCount = 0;
          for (let p1 = 0; p1 < this.paidbingoMoneyFromYesterday.length; p1++) {
            if (
              this.paidKenoMoneyFromYesterday[p].cashierName ==
              this.paidbingoMoneyFromYesterday[p1].cashierName
            ) {
              matchCount++;

              this.paidAllMoneyFromYesterday.push({
                cashierName: this.paidKenoMoneyFromYesterday[p].cashierName,
                paidMoney:
                  this.paidKenoMoneyFromYesterday[p].paidMoney +
                  this.paidbingoMoneyFromYesterday[p1].paidMoney,
              });
            }
          }
          if (matchCount == 0) {
            this.paidAllMoneyFromYesterday.push({
              cashierName: this.paidKenoMoneyFromYesterday[p].cashierName,
              paidMoney: this.paidKenoMoneyFromYesterday[p].paidMoney,
            });
          }
        }

        for (let p = 0; p < this.paidbingoMoneyFromYesterday.length; p++) {
          let matchCount = 0;
          for (let p1 = 0; p1 < this.paidKenoMoneyFromYesterday.length; p1++) {
            if (
              this.paidKenoMoneyFromYesterday[p1].cashierName ==
              this.paidbingoMoneyFromYesterday[p].cashierName
            ) {
              matchCount++;
            }
          }
          if (matchCount == 0) {
            this.paidAllMoneyFromYesterday.push({
              cashierName: this.paidbingoMoneyFromYesterday[p].cashierName,
              paidMoney: this.paidbingoMoneyFromYesterday[p].paidMoney,
            });
          }
        }
      } catch (err) {}
    },
  },

  async created() {
    if (this.$store.state.admin != "") {
      await this.bingoGetDailyWorks("Today");
    } else this.$router.push({ name: "login" });
  },
};
</script>
<style scoped>
#error {
  max-width: 300px;
  margin: auto;
}

#dashboard {
  max-width: 1200px;
  margin: auto;
}
#report {
  max-width: 1000px;
  margin: auto;

  margin-top: 10px;
}

#chooseDate {
  max-width: 400px;
  margin: auto;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 7px;
  padding-right: 40px;
}

tr:nth-child(even) {
  background-color: #faf5f5;
}
.horizontal-scroll {
  scrollbar-width: initial;
}

.horizontal-scroll::-webkit-scrollbar {
  display: none;
}
</style>
